import React from "react";
import classNames from "classnames";
import { ButtonTag, Label } from "./styles";

export default function Button({
  color,
  bold,
  center,
  margin,
  textDecoration,
  style,
  children,
  pd,
  pv,
  bg,
  br,
  label,
  size,
  flex,
  box,
  hover,
  className,
  ...others
}) {
  return (
    <a {...others}>
      <ButtonTag
        flex={flex}
        style={style}
        margin={margin}
        pv={pv}
        bg={bg}
        br={br}
        pd={pd}
        box={box}
        hover={hover}
        className={classNames(className)}
      >
        <Label
          size={size}
          bold={bold}
          center={center}
          color={color}
          textDecoration={textDecoration}
        >
          {label}
        </Label>
      </ButtonTag>
    </a>
  );
}
